import { checkPermission } from "@/api/base";

export function getArtworkPriceArrange(artwork, onlyPriceLow) {
  if (!artwork) return;
  if (artwork.saleType == 4) {
    if (artwork.sellPrice) return `￥${artwork.sellPrice}`;
    let goodTo = artwork.goodTo;
    if (goodTo && goodTo.goodStockList) {
      let priceLow = '';
      let priceHigh = '';
      let prices = getPrices(goodTo);
      if (prices.length == 1) {
        priceLow = prices[0];
      } else if (prices.length > 1) {
        prices.sort(sortNum);
        priceLow = prices[0];
        priceHigh = prices[prices.length - 1];
      }
      if (onlyPriceLow) return '¥ ' + priceLow;
      else return ticketPriceComputed(priceLow, priceHigh);
    }
  } else {
    // return artwork.saleType == 3 ? '拍卖' : artwork.saleType == 2 ? '议价' : artwork.saleType == 1 ? '非卖品' : ''
    return artwork.saleType == 3 ? '拍卖' : artwork.saleType == 2 ? '议价' : '';
  }
}
export function getPriceArrange(data) {
  if (!data) return '';
  let goodTo = data;
  let price = '';
  if (goodTo && goodTo.goodStockList) {
    let priceLow = '';
    let priceHigh = '';
    let prices = getPrices(goodTo);
    if (prices.length == 1) {
      price = '¥ ' + prices[0];
    } else if (prices.length > 1) {
      prices.sort(sortNum);
      priceLow = prices[0];
      priceHigh = prices[prices.length - 1];
      if (priceLow == priceHigh) price = '¥ ' + priceLow;
      else price = '¥ ' + priceLow + '-' + priceHigh;
    }
  }else{
    price = '¥ ' + goodTo.sellPrice //移动端saas后台没有多规格商品，所以显示一个价格
  }
  return price;
}
export function getVipPriceArrangeData(data) {
  let res = {};
  if (data) {
    let goodStockList = data.goodStockList;
    if (goodStockList && goodStockList.length > 1) {
      let first = goodStockList[0];
      let vipMin = first.memberPrice;
      let vipMax = first.memberPrice;
      for (let i = 0; i < goodStockList.length; i++) {
        let good = goodStockList[i];
        if (good.memberPrice > vipMax) vipMax = good.memberPrice;
        if (good.memberPrice < vipMin) vipMin = good.memberPrice;
      }
      if (vipMax == vipMin) {
        res.vipPrice = vipMax;
      } else {
        res.vipPrice = vipMin + '-' + vipMax;
      }
    } else {
      res.vipPrice = data.memberPrice;
    }
    if (!res.vipPrice || res.vipPrice.length == 0) {
      res.vipPrice = data.memberPrice;
    }
    if (res.vipPrice >= 0) {
      res.mark = data.mainCurrency && data.mainCurrency.mark ? data.mainCurrency.mark : '¥';
      res.type = data.memberPriceType;
    }
  }
  return res;
}
export function getVipPriceData(data) {
  let res = {};
  if (data) {
    res.mark = data.mainCurrency && data.mainCurrency.mark ? data.mainCurrency.mark : '¥';
    res.vipPrice = data.memberPrice;
    res.type = data.memberPriceType;
  }
  return res;
}
//格式化价格
export function getPriceStr(value) {
  if (!value && value != 0) {
    return '';
  }

  return '¥' + value.toFixed(2);
}
export function isMiniWechat() {
  let state = false;
  wx.miniProgram.getEnv(function(res) {
    if (res.miniprogram) {
      state = true;
    } else {
      state = false;
    }
  });
  return state;
}

function getPrices(goodTo) {
  let price = [];
  if (goodTo.goodStockList && goodTo.goodStockList.length) {
    for (let i = 0; i < goodTo.goodStockList.length; i++) {
      price.push(goodTo.goodStockList[i].sellPrice);
    }
  }
  return price;
}
function sortNum(a, b) {
  return a - b;
}

export function getShareDataWithDetail(details) {
  let obj = {};
  let detail = Object.assign({}, details);
  if (detail) {
    let goodTo = detail.goodTo;
    obj = detail;
    for (let key in obj) {
      if (typeof obj[key] === 'object') {
        delete obj[key];
      }
    }

    if (goodTo && goodTo.id) {
      for (let key in goodTo) {
        if (typeof goodTo[key] === 'object') {
          delete goodTo[key];
        }
      }
      obj.goodTo = goodTo;
    }
  }
  // console.log("xxxx obj = ", obj)
  return obj;
}

export function getDescriptionOfDetails(detail) {
  let res = '';
  let start = 0;
  if (detail.author && detail.author.length) {
    start = 1;
    res += detail.author;
  }
  if (detail.year && detail.year.length) {
    res += start == 1 ? ' / ' : '';
    res += detail.year;
    start = 1;
  }
  if (detail.size && detail.size.length) {
    res += start == 1 ? ' / ' : '';
    res += detail.size;
    start = 1;
  }
  if (detail.material && detail.material.length) {
    res += start == 1 ? ' / ' : '';
    res += detail.material;
    start = 1;
  }
  if (detail.padescription && detail.padescription.length) {
    res += start == 1 ? ' / ' : '';
    res += detail.padescription;
  }
  if (detail.process && detail.process.length) {
    res += start == 1 ? ' / ' : '';
    res += detail.process;
  }
  if (res.length > 3 && res.charAt(res.length - 3) == ' / ') {
    res = res.substring(0, res.length - 3);
  }
  return res;
}
export function formatLargePrice(p, mainPrice) {
  if (!mainPrice) mainPrice = '¥';
  let price = parseInt(p);
  if (price < 10000) return mainPrice + p;
  let wan =
    price % 10000 == 0
      ? parseInt(price / 10000)
      : (parseFloat(price / 10000).toFixed(2) * 100) / 100;
  return mainPrice + wan + '万';
}

export function formatAucPriceRangeWithCurrencyType(priceLow, priceHigh, currency) {
  if (priceLow >= 0 && priceHigh >= 0) {
    if (priceLow == priceHigh) {
      return largePrice(priceHigh, currency);
    }
    return largePrice(priceLow, currency) + '-' + largePrice(priceHigh, currency);
  } else if (priceLow) {
    return largePrice(priceLow, currency);
  } else if (priceHigh) {
    return largePrice(priceHigh, currency);
  }
}
function largePrice(p, currency) {
  if (!currency) currency = '';
  let price = parseInt(p);
  if (price < 10000) return currency + p;
  let wan =
    price % 10000 == 0
      ? parseInt(price / 10000)
      : (parseFloat(price / 10000).toFixed(2) * 100) / 100;
  return currency + wan + '万';
}
// 获取百分比
export function getFloatNum(value) {
  return Math.floor(value * 10000) / 100;
}
export function formatAuctionPrice(priceLow, priceHigh) {
  if (priceLow >= 0 && priceHigh >= 0) {
    if (priceLow == priceHigh) {
      return largePrice(priceHigh);
    }
    return largePrice(priceLow) + '-' + largePrice(priceHigh);
  } else if (priceLow || priceLow == 0) {
    return largePrice(priceLow);
  } else if (priceHigh || priceHigh == 0) {
    return largePrice(priceHigh);
  }
}

function ticketPriceComputed(priceLow, priceHigh) {
  if (priceLow && priceHigh) {
    if (priceLow == priceHigh) {
      return '¥ ' + priceHigh;
    }
    return '¥ ' + priceLow + '-' + priceHigh;
  } else if (priceLow) {
    return '¥ ' + priceLow;
  } else if (priceHigh) {
    return '¥ ' + priceHigh;
  } else if (priceLow === priceHigh && priceLow === 0) {
    return '¥ 0';
  } else {
    return '¥ 0';
  }
}
// 日期格式化 yyyy-mm-dd hh-mm-ss
export function formatDateTime(value) {
  let date = new Date(value);
  return value
    ? `${date.getFullYear()}-${leftPad(date.getMonth() + 1)}-${leftPad(date.getDate())} ${leftPad(
        date.getHours(),
      )}:${leftPad(date.getMinutes())}:${leftPad(date.getSeconds())}`
    : '';
}
function leftPad(n) {
  return n < 10 ? '0' + n : n;
}
// 日期格式化 yyyy-mm-dd hh-mm-ss
export function formatDate(value) {
  let date = new Date(value);
  return value
    ? `${date.getFullYear()}-${leftPad(date.getMonth() + 1)}-${leftPad(date.getDate())} `
    : '';
}


// 日期格式化 yyyy-mm-dd hh-mm
export function formatDateTimeMu(value, splitChar) {
  if (!value) {
    return '';
  }
  let spChar = '-';
  if (splitChar && splitChar.length) spChar = splitChar;
  let date = new Date(value);
  let result =
    date.getFullYear() +
    spChar +
    leftPad(date.getMonth() + 1) +
    spChar +
    leftPad(date.getDate()) +
    ' ' +
    leftPad(date.getHours()) +
    ':' +
    leftPad(date.getMinutes());
  return result;
}

export function auctionArtworkCanEdit(data) {
  let isPublish = data.flagDelete == 0 && data.isPublicAuction && data.isTiming == 0;
  let isStart = false;
  let nowdate = new Date();

  if (data.auctionTo) {
    // if (nowdate > data.auctionTo.aucStartTime) {
    //   isStart = true
    // } 同步拍无开始时间 所以废弃

    if (data.auctionTo.status || data.auctionTo.status === 0) {
      isStart = data.auctionTo.status != 0 && data.auctionTo.status != 5;
    }
    if (data.auctionTo.isAdvanceBid && nowdate > data.auctionTo.advanceBidTime) {
      isStart = true;
    }
  } else {
    if (nowdate > data.aucStartTime) {
      isStart = true;
    }
    if (data.status != 0 && data.status != 5) {
      isStart = true;
    }
  }
  return !isPublish || !isStart;
}

export function getArtworkDesc(artwork) {
  var author = artwork.author ? artwork.author + '/' : ''
  var year = artwork.year ? artwork.year + '/' : ''
  var padescription = artwork.padescription ? artwork.padescription + '/' : ''
  var size = artwork.size ? artwork.size : ''
  var res = author + year + padescription + size
  if (res.length > 1 && res.charAt(res.length - 1) == '/') {
    res = res.substring(0, res.length - 1)
  }
  return res
}
export function setMarginTypeData(detail) {
  let marginType = {
    name: '',
    amount: '',
  }
  if (detail) {
    let marginPaymentTypeList = detail.marginPaymentTypeList || []

    if (
      detail.marginPaymentType == 4 ||
      detail.marginPaymentType == 5 ||
      detail.marginPaymentType == 6 ||
      detail.marginPaymentType == 7
    ) {
      marginType.name = '多种保证金'
      return `${marginType.name}`
    } else {
      if (marginPaymentTypeList.length > 1) {
        marginType.name = '多种保证金'
      } else if (marginPaymentTypeList.length == 1) {
        let margin = marginPaymentTypeList[0]
        if (margin.marginPaymentType == 2) {
          marginType.name = '拍品保证金'
        } else if (margin.marginAmount == 0) {
          marginType.name = '保证金 无'
        } else {
          if (margin.marginPaymentType == 3) {
            marginType.name = '多专场保证金'
          } else if (margin.marginPaymentType == 1) {
            marginType.name = '专场保证金'
          }
          if (margin.marginAmount > 0) {
            marginType.amount = margin.marginAmount
          }
        }
      } else {
        if (detail.marginPaymentType == 2) {
          marginType.name = '拍品保证金'
        } else if (detail.marginPaymentType == 8) {
          marginType.name = `比例保证金：1:${detail.marginRatioTo.ratio}`
        } else {
          if (detail.marginPaymentType == 3) {
            marginType.name = '多专场保证金'
          } else if (detail.marginPaymentType == 1) {
            marginType.name = '专场保证金'
          }
          if (detail.specialMarginAmount > 0) {
            marginType.amount = detail.specialMarginAmount
          }
        }
      }
      return `${marginType.name}${
        marginType.amount > 0 && detail.mainCurrency
          ? detail.mainCurrency.mark + marginType.amount
          : ''
      }`
    }
  }
}

// 日期格式化 yyyy-mm-dd hh-mm
export function formatDateTimehhmm(value) {
  let date = new Date(value)
  return value
    ? `${date.getFullYear()}-${leftPad(date.getMonth() + 1)}-${leftPad(
        date.getDate()
      )} ${leftPad(date.getHours())}:${leftPad(date.getMinutes())}`
    : ''
}



export function validateKeywords(value){
  const verificationStr = /古董|文物|秦代|汉代|唐代|宋代|元代|明代|清代|秦朝|汉朝|唐朝|宋朝|元朝|明朝|清朝/
  if(!verificationStr.test(value)){
    return false
  }else{
    return `请更正敏感词 ${verificationStr.exec(value)}`
  }
}

export function pullCustomPermission({ commit }, uri) {
  return new Promise(function(resolve, reject) {
    checkPermission({ uri })
      .then(res => {
        // commit("saveCustomPermission", {
        //   uri,
        //   value: res.data.hasPermission
        // });
        resolve(res)
      })
      .catch(err => {
        reject(err)
      });
  });
}
